import "core-js/modules/es6.regexp.split";
import "core-js/modules/es6.array.sort";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "E:\\RiderProjects\\pdcweb\\node_modules\\@babel\\runtime-corejs2/helpers/esm/asyncToGenerator";
import "core-js/modules/es6.function.name";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { GroupbyName, SortField, toTree, getchild } from "../../utils/helper";
import { BalanceParaSet } from "../../api/Balance";
import { provinceAndCityData, CodeToText } from 'element-china-area-data';
var that;
var roleArr = [];
export default {
  name: 'balance',
  data: function data() {
    return {
      userEmpower: {
        userId: '',
        userName: '',
        balanceIds: '',
        balanceNames: '',
        checkedBalances: [null]
      },
      balanceArr: [],
      balanceArrGroup: [],
      roles: [],
      deptArr: [],
      UpdateRoleAndDept: false,
      deptTree: [],
      isResouceShow: 0,
      isAdmin: false,
      tableHeight: window.innerHeight * 0.6,
      headTitle: '',
      viewVisible: false,
      isadd: false,
      balance: {},
      UserArr: [],
      paramSet: {},
      editVisible: false,
      paramVisible: false,
      isDisplayCompanyName: false,
      balances: [],
      pageCount: 1,
      multipleSelection: [],
      delList: [],
      loading: false,
      query: {
        Field1: '',
        Field2: '',
        PageIndex: 1,
        PageSize: 15
      },
      volidArr: [],
      FrequencyArr: [],
      rules: {
        code: [{
          required: true,
          message: '请输入编号',
          trigger: 'blur'
        }, {
          min: 1,
          max: 15,
          message: '长度在 1 到 15 个字符',
          trigger: 'blur'
        }],
        name: [{
          required: true,
          message: '请输入名称',
          trigger: 'blur'
        }],
        mineName: [{
          required: true,
          message: '请输入煤矿名称',
          trigger: 'blur'
        }],
        frequencyId: [{
          required: true,
          message: '请选择计划',
          trigger: 'blur'
        }],
        titleStyleType: [{
          required: true,
          message: '请选择标题样式',
          trigger: 'blur'
        }],
        balanceType: [{
          required: true,
          message: '请选择设备类型',
          trigger: 'blur'
        }],
        agreementType: [{
          required: true,
          message: '请选择协议类型',
          trigger: 'blur'
        }]
      },
      AgreementVersion: [],
      equimentType: [],
      parameterProtocolType: [],
      commType: [],
      speedOn_OffSwitchType: [{
        name: '常开',
        value: '0'
      }, {
        name: '常闭',
        value: '1'
      }],
      speedSetSwitchType: [{
        name: '关闭',
        value: '0'
      }, {
        name: '开启',
        value: '1'
      }],
      titleStyleType: [{
        name: '矿井+设备名称',
        value: 0
      }, {
        name: '自定标题',
        value: 1
      }],
      isDB14Type: [{
        name: '否',
        value: 0
      }, {
        name: '是',
        value: 1
      }],
      HomePageDisplayType: [{
        name: '否',
        value: 0
      }, {
        name: '是',
        value: 1
      }],
      breedCodeType: [{
        name: '入洗原煤',
        value: 1
      }, {
        name: '大块煤',
        value: 2
      }, {
        name: '中块煤',
        value: 3
      }, {
        name: '小块煤',
        value: 4
      }, {
        name: '沫煤',
        value: 5
      }, {
        name: '中煤',
        value: 6
      }, {
        name: '煤泥',
        value: 7
      }, {
        name: '矸石',
        value: 8
      }, {
        name: '入选原煤',
        value: 9
      }, {
        name: '洗末精煤',
        value: 10
      }, {
        name: '洗块精煤',
        value: 11
      }, {
        name: '筛混煤',
        value: 12
      }],
      pRules: {
        speedSet: [{
          // required: true,
          // message: '请输入给定速度',
          // trigger: 'blur'
          validator: function validator(rule, value, callback) {
            if (value === "") {
              callback(new Error("请输入模拟速度值"));
            } else if (!/^[0-5](\.\d{1,2})?$/.test(value)) {
              callback(new Error("只能输入 0-5 范围内的两位小数"));
            } else {
              callback();
            }
          },
          trigger: 'blur'
        }],
        zerov: [{
          // required: true,
          // message: '请输入零点值',
          // trigger: 'blur'
          validator: function validator(rule, value, callback) {
            if (value === "") {
              callback(new Error("请输入零点值"));
            } else if (!/^([0-9]|[1-2][0-9]|30)(\.\d{1,4})?$/.test(value)) {
              callback(new Error("只能输入 0-30 范围内的四位小数"));
            } else {
              callback();
            }
          },
          trigger: 'blur'
        }],
        kv2: [{
          // required: true,
          // message: '请输入系数值',
          // trigger: 'blur'
          validator: function validator(rule, value, callback) {
            if (value === "") {
              callback(new Error("请输入系数值"));
            } else if (!/^([0-9]|1[0-9]|20)(\.\d{1,4})?$/.test(value)) {
              callback(new Error("只能输入 0-20 范围内的四位小数"));
            } else {
              callback();
            }
          },
          trigger: "blur"
        }]
      },
      options: provinceAndCityData,
      selectedOptions: []
    };
  },
  filters: {
    balancetypeFormat: function balancetypeFormat(UserType) {
      var usertypeName = '';
      var list = that.equimentType.filter(function (x) {
        return x.value == UserType;
      });

      if (list.length > 0) {
        usertypeName = list[0].name;
      }

      return usertypeName;
    },
    commtypeFormat: function commtypeFormat(UserType) {
      var usertypeName = '';
      var list = that.commType.filter(function (x) {
        return x.value == UserType;
      });

      if (list.length > 0) {
        usertypeName = list[0].name;
      }

      return usertypeName;
    },
    agreementTypeFormat: function agreementTypeFormat(UserType) {
      var usertypeName = '';
      var list = that.AgreementVersion.filter(function (x) {
        return x.id == UserType;
      });

      if (list.length > 0) {
        usertypeName = list[0].name;
      }

      return usertypeName;
    },
    usertypeFormat: function usertypeFormat(UserType) {
      var usertypeName = '';
      var item = roleArr.filter(function (t) {
        return t.id == UserType;
      });
      usertypeName = item.length > 0 ? item[0]['name'] : '';
      return usertypeName;
    }
  },
  created: function () {
    var _created = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee() {
      var res, search, resequ, search1, search2;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.$zybhttp.get('Balance/GetAgreementVersion', {});

            case 2:
              res = _context.sent;

              if (res.data.status == 0) {
                this.AgreementVersion = res.data.data;
              }

              search = {
                Field2: 'equimentType',
                Field4: '1'
              };
              _context.next = 7;
              return this.$zybhttp.post('DataCode/GetStructList', search);

            case 7:
              resequ = _context.sent;

              if (resequ.data.status == 0) {
                this.equimentType = resequ.data.data.list;
              }

              search1 = {
                Field2: 'commType',
                Field4: '1'
              };
              _context.next = 12;
              return this.$zybhttp.post('DataCode/GetStructList', search1);

            case 12:
              resequ = _context.sent;

              if (resequ.data.status == 0) {
                this.commType = resequ.data.data.list;
              }

              ;
              search2 = {
                Field2: 'ParameterProtocol',
                Field4: '1'
              };
              _context.next = 18;
              return this.$zybhttp.post('DataCode/GetStructList', search2);

            case 18:
              resequ = _context.sent;

              if (resequ.data.status == 0) {
                this.parameterProtocolType = resequ.data.data.list;
              }

              ;
              this.getUsers();
              this.getDept();
              this.getRoles();

            case 24:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function created() {
      return _created.apply(this, arguments);
    }

    return created;
  }(),
  beforeCreate: function beforeCreate() {
    that = this;
  },
  mounted: function mounted() {
    this.getData();
    this.volidBalance();
  },
  methods: {
    saveEdit: function saveEdit() {
      var _this = this;

      this.$refs['balance'].validate(function (valid) {
        if (valid) {
          var parentidPath = _this.balance.DeptIdTree;
          _this.balance.companyId = parentidPath[parentidPath.length - 1] + '';
          _this.isResouceShow = _this.isResouceShow + 1;
          _this.balance.isUse = _this.balance.isUse ? '1' : '0';
          _this.balance.isShowMonitor = _this.balance.isShowMonitor ? '1' : '0';
          _this.balance.isHomePageDisplay = _this.balance.isHomePageDisplay ? 1 : 0;
          _this.balance.userName = _this.userEmpower.balanceNames; //this.balance.balanceIds = this.userEmpower.checkedBalances.join(',');

          if (_this.selectedOptions.length == 0) {
            _this.$notify.warning('请选择地区!!!');

            return;
          }

          var loc = [];

          for (var i = 0; i < _this.selectedOptions.length; i++) {
            loc.push(CodeToText[_this.selectedOptions[i]]);
          }

          _this.balance.provincecityCode = _this.selectedOptions.join('/');
          _this.balance.provinceCity = loc.join('/');

          if (_this.isadd) {
            _this.$zybhttp.post('Balance/BalanceAdd', _this.balance).then(function (res) {
              if (res.data.status == 0) {
                _this.$notify.success('添加成功');

                _this.getData();

                _this.editVisible = false;
                _this.balance = {};
              } else {
                _this.$notify.error(res.data.msg);
              }
            }).catch(function (err) {
              return _this.$notify.error('网络异常！添加失败');
            });
          } else {
            var ms_userInfo = localStorage.getItem('ms_userInfo');
            var userinfo = JSON.parse(ms_userInfo);
            _this.balance.modifyUserId = userinfo.id + '';

            _this.$zybhttp.post('Balance/BalanceUpdate', _this.balance).then(function (res) {
              if (res.data.status == 0) {
                _this.$notify.success(res.data.msg);

                _this.getData();

                _this.editVisible = false;
              } else {
                _this.$notify.error(res.data.msg);
              }
            }).catch(function (err) {
              return _this.$notify.error('网络异常！修改失败');
            });
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    saveParam: function saveParam() {
      var _this2 = this;

      this.$refs['paramSet'].validate(function (valid) {
        if (valid) {
          _this2.$zybhttp.post('Balance/BalanceParaSet', _this2.paramSet).then(function (res) {
            if (res.data.status == 0) {
              _this2.$notify.success('参数设置成功');

              _this2.getData();

              _this2.paramVisible = false;
              _this2.paramSet = {};
            } else {
              _this2.$notify.error(res.data.msg);
            }
          }).catch(function (err) {
            return _this2.$notify.error('网络异常！添加失败');
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    clsOpt: function clsOpt() {
      this.getData();
    },
    getData: function getData() {
      var _this3 = this;

      var userInfo = JSON.parse(localStorage.getItem('ms_userInfo'));
      this.$zybhttp.post('Balance/GetList', {
        Field1: userInfo.userType,
        Field2: userInfo.id + '',
        Field3: userInfo.realName
      }).then(function (res) {
        if (res.data.status == 0) {
          res = res.data;
          var d = res.data.list;
          var newdata = d.sort(SortField('Id', 'desc'));
          newdata = newdata.map(function (x) {
            x.isUseFt = x.isUse == '1';
            x.isUseMonitor = x.isShowMonitor == '1';
            x.isUseHomePageDisplay = x.isHomePageDisplay == '1';
            return x;
          }, []);
          _this3.balances = newdata;
          _this3.pageCount = res.data.total || 0;
          _this3.isAdmin = userInfo.id == 1 ? true : false;
          _this3.isDisplayCompanyName = res.info1 == "是" ? true : false;
        } else {
          _this3.$notify.error(res.message);
        }
      }).catch(function (err) {
        return _this3.$notify.error('网络异常！获取列表失败！');
      });
    },
    getFrequency: function getFrequency() {
      var _this4 = this;

      var serach = {};
      this.$zybhttp.post('Frequency/GetList', serach).then(function (res) {
        if (res.data.status == 0) {
          var d = res.data.data.list;
          _this4.FrequencyArr = d.sort(SortField('id', 'asc'));
        } else {
          _this4.$notify.error(res.message);
        }
      }).catch(function (err) {
        return _this4.$notify.error('网络异常！获取列表失败！');
      });
    },
    getAxiso: function getAxiso() {
      this.$zybhttp.get('Balance/BalanceDel?ids=1').then(function (res) {}).catch(function (err) {
        return console.log(err, '网络异常！获取列表失败！');
      });
    },
    handleEdit: function handleEdit(id, row) {
      this.getFrequency();
      this.balance = JSON.parse(JSON.stringify(row)); // row;

      var ms_userInfo = localStorage.getItem('ms_userInfo');
      var userinfo = JSON.parse(ms_userInfo);
      this.isAdmin = userinfo.id == 1 ? true : false;
      this.balance.id = id;
      this.editVisible = true;
      this.balance.isUse = this.balance.isUse == 1;
      this.balance.isShowMonitor = this.balance.isShowMonitor == 1;
      this.balance.isHomePageDisplay = this.balance.isHomePageDisplay ? 1 : 0;
      this.selectedOptions = this.balance.provinceCityCode == null ? [] : this.balance.provinceCityCode.split('/');
      this.isadd = false;

      if (this.balance.name.split(':').length > 1) {
        this.balance.name = this.balance.name.split(':')[1];
      } else {
        this.balance.name = this.balance.name.split(':')[0];
      }

      var arr = new Array();

      if (this.balance.companyId != '0') {
        var d = this.balance.parentIdPath.split(','); //var d = this.balance.companyId.split(',');

        var char = userinfo.deptId;

        if (d.indexOf(char) > -1) {
          var a = d.slice(d.indexOf(char), d.length);

          for (var i = 0; i < a.length; i++) {
            arr.push(parseInt(a[i]));
          }
        }
      }

      arr.push(parseInt(this.balance.companyId));
      this.balance.DeptIdTree = arr;
      this.userEmpower = JSON.parse(JSON.stringify(row)); // row;

      this.userEmpower.id = id;

      if (this.userEmpower.balanceIds != null) {
        var db = this.userEmpower.balanceIds.split(',');
        var arrDb = [];

        for (var i = 0; i < db.length; i++) {
          arrDb.push(parseInt(db[i]));
        }

        this.userEmpower.checkedBalances = arrDb;
      }

      this.headTitle = '修改设备信息';
      this.UpdateRoleAndDept = userinfo.loginId == row.LoginId;
    },
    dbSelected: function dbSelected(row) {
      this.getFrequency();
      this.balance = JSON.parse(JSON.stringify(row)); // row;

      var ms_userInfo = localStorage.getItem('ms_userInfo');
      var userinfo = JSON.parse(ms_userInfo);
      this.isAdmin = userinfo.id == 1 ? true : false;
      this.balance.id = row.id;
      this.editVisible = true;
      this.balance.isUse = this.balance.isUse == 1;
      this.balance.isShowMonitor = this.balance.isShowMonitor == 1;
      this.balance.isHomePageDisplay = this.balance.isHomePageDisplay ? 1 : 0;
      this.selectedOptions = this.balance.provinceCityCode == null ? [] : this.balance.provinceCityCode.split('/');
      this.isadd = false;

      if (this.balance.name.split(':').length > 1) {
        this.balance.name = this.balance.name.split(':')[1];
      } else {
        this.balance.name = this.balance.name.split(':')[0];
      }

      var arr = new Array();

      if (this.balance.companyId != '0') {
        var d = this.balance.parentIdPath.split(','); //var d = this.balance.companyId.split(',');

        var char = userinfo.deptId;

        if (d.indexOf(char) > -1) {
          var a = d.slice(d.indexOf(char), d.length);

          for (var i = 0; i < a.length; i++) {
            arr.push(parseInt(a[i]));
          }
        }
      }

      arr.push(parseInt(this.balance.companyId));
      this.balance.DeptIdTree = arr;
      this.userEmpower = JSON.parse(JSON.stringify(row)); // row;

      this.userEmpower.id = row.id;

      if (this.userEmpower.balanceIds != null) {
        var db = this.userEmpower.balanceIds.split(',');
        var arrDb = [];

        for (var i = 0; i < db.length; i++) {
          arrDb.push(parseInt(db[i]));
        }

        this.userEmpower.checkedBalances = arrDb;
      }

      this.headTitle = '修改设备信息';
      this.UpdateRoleAndDept = userinfo.loginId == row.LoginId;
    },
    handleShow: function handleShow(index, row) {
      this.balance = row;
      this.viewVisible = true;
    },
    handleAdd: function handleAdd() {
      this.getFrequency();
      var ms_userInfo = localStorage.getItem('ms_userInfo');
      var userinfo = JSON.parse(ms_userInfo);
      this.balance = {};
      this.isadd = true;
      var date = new Date();
      this.balance.createUserId = userinfo.id + '';
      this.balance.modifyUserId = userinfo.id + '';
      this.balance.userName = userinfo.realName;
      this.isAdmin = userinfo.id == 1 ? true : false;
      this.balance.rate = 9600;
      this.balance.parity = 0;
      this.balance.dataBits = 8;
      this.balance.stopBits = 1;
      this.editVisible = true;
      this.selectedOptions = [];
      this.headTitle = '新增设备信息';
    },
    handleChange: function handleChange() {
      var loc = '';

      for (var i = 0; i < this.selectedOptions.length; i++) {
        loc += CodeToText[this.selectedOptions[i]];
      }
    },
    handlePageChange: function handlePageChange(val) {
      this.$set(this.query, 'PageIndex', val);
      this.getData();
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    delAllSelection: function delAllSelection() {
      var _this5 = this;

      var length = this.multipleSelection.length;
      var str = '';
      var strValue = '';
      this.delList = this.delList.concat(this.multipleSelection);

      for (var i = 0; i < length; i++) {
        str += this.multipleSelection[i].name + ' ';
        strValue += this.multipleSelection[i].id + ',';
      }

      if (strValue.length == 0) {
        this.$notify.warning('请选择删除的行！');
        return;
      }

      this.$confirm('确定要删除吗？', '提示', {
        type: 'warning'
      }).then(function () {
        _this5.$zybhttp.get('Balance/BalanceDel', {
          params: {
            ids: strValue
          }
        }).then(function (res) {
          if (res.data.status == 0) {
            _this5.$notify.success("\u5220\u9664\u4E86".concat(str));

            _this5.getData();
          } else {
            _this5.$notify.error(res.data.msg);
          }
        }).catch(function (err) {
          return _this5.$notify.error('网络异常！删除失败');
        });

        _this5.multipleSelection = [];
      }).catch(function () {});
    },
    paramSetFun: function () {
      var _paramSetFun = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee2() {
        var length, data, res, pdata;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                length = this.multipleSelection.length;
                data = {};

                if (!(length == 0)) {
                  _context2.next = 5;
                  break;
                }

                this.$notify.warning('请选择设置参数的行！');
                return _context2.abrupt("return");

              case 5:
                if (!(length > 1)) {
                  _context2.next = 8;
                  break;
                }

                this.$notify.warning('只能选择一行！');
                return _context2.abrupt("return");

              case 8:
                data = this.multipleSelection[0];

                if (!(data.isUse != '1')) {
                  _context2.next = 12;
                  break;
                }

                this.$notify.warning('只有启用的才能设置参数！');
                return _context2.abrupt("return");

              case 12:
                _context2.next = 14;
                return BalanceParaSet(data.id);

              case 14:
                res = _context2.sent;

                if (!(res.status != 0)) {
                  _context2.next = 20;
                  break;
                }

                this.$notify.warning(res.msg);
                return _context2.abrupt("return");

              case 20:
                this.paramVisible = true;
                pdata = res.data;
                this.paramSet = pdata;

              case 23:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function paramSetFun() {
        return _paramSetFun.apply(this, arguments);
      }

      return paramSetFun;
    }(),
    indexMethod: function indexMethod(index) {
      return index + 1;
    },
    changeUse: function changeUse(row) {
      var _this6 = this;

      row.isUse = row.isUseFt ? '1' : '0';
      var balanceType = row.balanceType;

      if (balanceType == '2' && this.volidArr.indexOf(row.id + '') > -1) {
        this.$notify.warning('该给料机在秤组中已启用，不允许停用！');
        this.getData();
        return;
      }

      if (row.name.split(':').length > 1) {
        row.name = row.name.split(':')[1];
      } else {
        row.name = row.name.split(':')[0];
      }

      this.$zybhttp.post('Balance/BalanceUpdate', row).then(function (res) {
        if (res.data.status == 0) {
          _this6.$notify.success(res.data.msg);

          _this6.getData();
        } else {
          _this6.$notify.error(res.data.msg);
        }
      }).catch(function (err) {
        return _this6.$notify.error('网络异常！修改失败');
      });
    },
    changeShowMonitor: function changeShowMonitor(row) {
      var _this7 = this;

      row.isShowMonitor = row.isUseMonitor ? '1' : '0';
      var balanceType = row.balanceType;

      if (row.name.split(':').length > 1) {
        row.name = row.name.split(':')[1];
      } else {
        row.name = row.name.split(':')[0];
      }

      this.$zybhttp.post('Balance/BalanceUpdate', row).then(function (res) {
        if (res.data.status == 0) {
          _this7.$notify.success(res.data.msg);

          _this7.getData();
        } else {
          _this7.$notify.error(res.data.msg);
        }
      }).catch(function (err) {
        return _this7.$notify.error('网络异常！修改失败');
      });
    },
    changeHomePageDisplay: function changeHomePageDisplay(row) {
      var _this8 = this;

      row.isHomePageDisplay = row.isUseHomePageDisplay ? 1 : 0;
      var balanceType = row.balanceType;

      if (row.name.split(':').length > 1) {
        row.name = row.name.split(':')[1];
      } else {
        row.name = row.name.split(':')[0];
      }

      this.$zybhttp.post('Balance/BalanceUpdate', row).then(function (res) {
        if (res.data.status == 0) {
          _this8.$notify.success(res.data.msg);

          _this8.getData();
        } else {
          _this8.$notify.error(res.data.msg);
        }
      }).catch(function (err) {
        return _this8.$notify.error('网络异常！修改失败');
      });
    },
    volidBalance: function volidBalance() {
      var _this9 = this;

      this.$zybhttp.get('Balance/GetScaleBalance').then(function (res) {
        if (res.data.status == 0) {
          var d = res.data.data;
          _this9.volidArr = d.split(',');
        } else {
          _this9.$notify.error(res.message);
        }
      }).catch(function (err) {
        return _this9.$notify.error('网络异常！获取列表失败！');
      });
    },
    stateFormat: function stateFormat(row, column) {
      if (row.communicationType === 0) {
        return row.rate;
      } else {
        return row.ip;
      }
    },
    getUsers: function getUsers() {
      var _this10 = this;

      this.$zybhttp.get('BalanceEmpower/GetUserList', {
        params: {
          userId: ''
        }
      }).then(function (res) {
        if (res.data.status == 0) {
          var d = res.data.data.list;
          _this10.UserArr = d; // for (var i = 0; i < d.length; i++) {
          //     var item = d[i];
          //     if (item.userType == '1') {
          //         item.name = '超级管理员';
          //     } else if (item.userType == '2') {
          //         item.name = '管理员';
          //     } else if (item.userType == '3') {
          //         item.name = '普通用户';
          //     } else if (item.userType == '4') {
          //         item.name = '游客';
          //     }
          // }

          var dd = GroupbyName(d, 'name');
          var narr = [];

          for (var i = 0; i < dd.length; i++) {
            var itemA = dd[i];
            narr.push({
              label: itemA.name,
              options: itemA.data
            });
          }

          _this10.balanceArrGroup = narr;
          _this10.balanceArr = d;
        } else {
          _this10.$notify.error(res.message);
        }
      }).catch(function (err) {
        return _this10.$notify.error('网络异常！获取列表失败！');
      });
    },
    getDept: function getDept() {
      var _this11 = this;

      var serach = {};
      this.$zybhttp.post('Dept/GetList', {
        Field3: '1'
      }).then(function (res) {
        if (res.data.status == 0) {
          _this11.deptArr = res.data.data.list;
          var d = res.data.data.list;
          var userDept = parseInt(JSON.parse(window.localStorage.getItem('ms_userInfo')).deptId);
          var newdata = getchild(d, [userDept], userDept);
          d = d.filter(function (x) {
            return newdata.indexOf(x.id) > -1;
          });
          d = d.sort(SortField('id', 'asc'));
          var arr = [];

          for (var i = 0; i < d.length; i++) {
            arr.push({
              id: d[i].id,
              pid: d[i].parentId,
              value: d[i].id,
              label: d[i].name
            });
          }

          _this11.deptTree = toTree(arr);
        } else {
          _this11.$notify.error(res.message);
        }
      }).catch(function (err) {
        return _this11.$notify.error('网络异常！获取列表失败！');
      });
    },
    getRoles: function getRoles() {
      var _this12 = this;

      // this.loading=true;
      var userInfo = JSON.parse(localStorage.getItem('ms_userInfo'));
      this.$zybhttp.post('role/GetList', {
        Field3: userInfo.id + ''
      }).then(function (res) {
        if (res.data.status == 0) {
          res = res.data;
          var d = res.data.list;
          var newdata = d.sort(SortField('Id', 'desc'));
          newdata = newdata.map(function (x) {
            x.id = x.id + '';
            return x;
          }, []);
          _this12.roles = newdata;
          roleArr = newdata;
          var userDept = parseInt(userInfo.deptId);
          var newdata = getchild(_this12.deptArr, [userDept], userDept);
          _this12.query.Field3 = newdata.join(',');

          _this12.getData();
        } else {
          _this12.$notify.error(res.message);
        }
      }).catch(function (err) {
        return _this12.$notify.error('网络异常！获取列表失败！');
      });
    },
    chgBalance: function chgBalance(e) {
      var obj = [];
      this.balanceArr.map(function (item) {
        //  this.unitList 是你 select option遍历的集合 e 是选中的id
        if (e.indexOf(item.id) > -1) {
          obj.push(item.realName);
        }
      });
      this.userEmpower.balanceNames = obj.join(',');
      this.$forceUpdate();
    }
  }
};